const KEY = "un_future_funds_v1";

export const FUND_TYPES = [
  "Experience",
  "Travel",
  "Learning",
  "Well-being",
  "Contribution",
  "Treat",
  "Shopping",
  "Drinks / alcohol",
  "Night out",
  "Rest",
  "Other",
];

export const listFutureFunds = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const persist = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
  return items;
};

export const addFutureFund = (payload) => {
  for (const v of [payload.goal, payload.setAside, payload.saved]) {
    if (v !== undefined && v !== "" && v !== null && (!Number.isFinite(Number(v)) || Number(v) < 0)) throw new Error("Amounts must be nonnegative numbers");
  }
  const current = listFutureFunds();
  const entry = {
    id: `fund_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    title: payload.title.trim(),
    type: payload.type || "Experience",
    why: payload.why?.trim() || "",
    when: payload.when?.trim() || "",
    nextStep: payload.nextStep?.trim() || "",
    timeAttention: payload.timeAttention?.trim() || "",
    goal: payload.goal ? Number(payload.goal) : null,
    setAside: payload.setAside ? Number(payload.setAside) : null,
    saved: payload.saved ? Number(payload.saved) : 0,
    createdAt: new Date().toISOString(),
  };
  persist([entry, ...current]);
  return entry;
};

export const updateFutureFund = (id, patch) => {
  const next = listFutureFunds().map((item) => (item.id === id ? { ...item, ...patch } : item));
  persist(next);
  return next.find((item) => item.id === id) || null;
};

export const deleteFutureFund = (id) => {
  return persist(listFutureFunds().filter((item) => item.id !== id));
};
